module.exports = __webpack_public_path__ + "static/media/Shroud for Truncheon Meter V2.d8da7141.webp";